export default "__VITE_ASSET__C4SnH8gH__"